import React, { useState, useEffect } from 'react';

const ranges = ['Live', '12 Hours', '24 Hours', '1 Week', '1 Month', 'Custom'];

function TimeRangeSelector({
  units = [],
  onRangeChange,
  onUnitChange,
  selectedUnit = '',
  groupId = 'time-range',
}) {
  const [active, setActive] = useState('Live');
  const [unit, setUnit] = useState(selectedUnit);

  useEffect(() => {
    setUnit(selectedUnit);
  }, [selectedUnit]);

  const handleRange = (range) => {
    setActive(range);
    if (onRangeChange) onRangeChange(range);
  };

  const handleUnit = (e) => {
    const value = e.target.value;
    setUnit(value);
    if (onUnitChange) onUnitChange(value);
  };

  return (
    <div
      className="relative flex w-full flex-col gap-3 rounded-[1.5rem] border border-white/5 bg-[#10131a]/80 px-3 py-3 text-white shadow-xl shadow-black/30 backdrop-blur-xl sm:flex-row sm:items-center sm:gap-4 md:px-4"
      id={groupId}
    >
      <div className="flex w-full flex-col gap-1 sm:max-w-xs">
        <span className="text-[10px] uppercase tracking-[0.25em] text-white/40">Unit</span>
        <div className="relative">
          <select
            value={unit}
            onChange={handleUnit}
            className="w-full appearance-none rounded-xl border border-white/10 bg-[#0b111d]/90 px-3 py-2 pr-10 text-sm font-semibold text-white shadow-inner shadow-black/40 transition focus:border-[#bf1d2e]/60 focus:outline-none focus:ring-2 focus:ring-[#bf1d2e]/40"
          >
            <option value="" style={{ backgroundColor: '#0b111d', color: '#f8fafc' }}>
              Select Unit
            </option>
            {units.map((u) => (
              <option
                key={u}
                value={u}
                style={{ backgroundColor: '#0b111d', color: '#f8fafc' }}
              >
                {u}
              </option>
            ))}
          </select>
          <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-white/60">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              className="h-4 w-4"
            >
              <path
                fillRule="evenodd"
                d="M5.23 7.21a.75.75 0 011.06.02L10 10.939l3.71-3.71a.75.75 0 111.06 1.061l-4.24 4.25a.75.75 0 01-1.06 0l-4.25-4.25a.75.75 0 01.02-1.06z"
                clipRule="evenodd"
              />
            </svg>
          </span>
        </div>
      </div>

      <div className="flex w-full flex-col gap-1">
        <span className="text-[10px] uppercase tracking-[0.25em] text-white/40">Time Range</span>
        <div className="relative">
          <select
            value={active}
            onChange={(e) => handleRange(e.target.value)}
            className="w-full appearance-none rounded-xl border border-white/10 bg-[#0b111d]/90 px-3 py-2 pr-10 text-sm font-semibold text-white shadow-inner shadow-black/40 transition focus:border-[#bf1d2e]/60 focus:outline-none focus:ring-2 focus:ring-[#bf1d2e]/40"
          >
            {ranges.map((range) => (
              <option
                key={range}
                value={range}
                style={{ backgroundColor: '#0b111d', color: '#f8fafc' }}
              >
                {range}
              </option>
            ))}
          </select>
          <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-white/60">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              className="h-4 w-4"
            >
              <path
                fillRule="evenodd"
                d="M5.23 7.21a.75.75 0 011.06.02L10 10.939l3.71-3.71a.75.75 0 111.06 1.061l-4.24 4.25a.75.75 0 01-1.06 0l-4.25-4.25a.75.75 0 01.02-1.06z"
                clipRule="evenodd"
              />
            </svg>
          </span>
        </div>
      </div>
    </div>
  );
}

export default TimeRangeSelector;
